import React, { useState, useEffect, useRef } from 'react';
import './NavbarMobile.scss';
import logo from '../../assets/img/Logo.jpg';
import { FaBars, FaTimes } from 'react-icons/fa';

function NavbarMobile() {
    const [isOpen, setIsOpen] = useState(false);
    const [showNav, setShowNav] = useState(true); // État pour afficher ou cacher la navbar
    const lastScrollY = useRef(0); // Pour garder la trace de la dernière position de défilement
    const menuRef = useRef();

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;

            if (currentScrollY > lastScrollY.current) {
                // Défilement vers le bas
                setShowNav(false);
            } else {
                // Défilement vers le haut
                setShowNav(true);
            }

            lastScrollY.current = currentScrollY;
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [menuRef]);

    return (
        <nav className={`navbarMobile ${showNav ? '' : 'hidden'}`}>
            <a href="/home">
                <img className='navbarMobile__logo' src={logo} alt="logo" />
            </a>
            {isOpen ? (
                <FaTimes className='navbarMobile__icon' onClick={toggleMenu} style={{ color: '#E6CF9A'}} />
            ) : (
                <FaBars className='navbarMobile__burgerIcon' onClick={toggleMenu} style={{ color: '#E6CF9A' }} />
            )}
            {isOpen && (
                <div className='navbarMobile__menu' ref={menuRef}>
                    <a className='navbarMobile__link' href="/home">Accueil</a>
                    <a className='navbarMobile__link' href="/about">A propos</a>
                    <a className='navbarMobile__link' href="/services">Services</a>
                    <a className='navbarMobile__link' href="/galerie">Galerie</a>
                    <a className='navbarMobile__link' href="/contact">Contact</a>
                </div>
            )}
        </nav>
    );
}

export default NavbarMobile;
